
import { getAMPMJobs } from '@/api';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { notificationErrorText } from '@/utils/PortalConstants';
import DateSelect from '@/components/dashBoard/selectsFields/components/DateSelect/DateSelect.vue';
import { AmPmJobs } from '@/models/reports';

@Component({
  components: {
    DateSelect,
    BackButton,
  },
  computed: {
    ...mapState('moduleUser', { userSelectedDates: 'userSelectedDates' }),
  },
})
export default class AmPmReport extends Vue {
  private isLoading = false;
  private dates: string[] = [];
  private statsReport: AmPmJobs = {
    customer_am: {},
    customer_pm: {},
    am_count: 0,
    pm_count: 0,
    total: 0,
    total_limit: 0,
    percentage: '',
  };
  private userSelectedDates!: string[];

  // Date lookup
  private changeDate(date: string): void {
    this.dates[0] = date;
  }

  private amPmJobs() {
    if (this.statsReport?.customer_am) {
      return Object.entries(this.statsReport?.customer_am);
    }
  }
  private pmPmJobs() {
    if (this.statsReport?.customer_pm) {
      return Object.entries(this.statsReport?.customer_pm);
    }
  }

  // Weekly report
  private getAMPMJobs() {
    this.isLoading = true;
    const params = {
      dates: this.dates,
    };
    getAMPMJobs(params)
      .then(res => {
        this.statsReport = res;
        console.log(this.statsReport);
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error getting AM/PM jobs',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private mounted(): void {
    this.dates[0] = this.userSelectedDates[0];
  }
}
